import React, { useState, useContext, Fragment, useEffect } from 'react';
import classNames from 'classnames';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Link as MyLookLink } from '../commonComponents';


import Context from 'Components/context';
import { language, LANG_JP, LANG_KR, LANG_MY, LANG_HK, LANG_TH, LANG_TWQ, LANG_ARABIA_EN, LANG_ARABIA, LANG_RU, LANG_FIL } from 'Root/constants';
import content from 'Content/content.json';
import { Lazada_icon, Shopee_icon, Qoo10_icon, Virtual_mirror} from '../commonComponents/svg';
import * as Icons from 'Images/newUi/header';
import { CrossDomainHelper } from '../helper/CrossDomainLink';
import Image from '../commonComponents/image/Image';
import './navbar.scss';
import { FormattedMessage, useIntl } from 'react-intl';

const ONLINE_STORES = process.env.REACT_APP_ONLINE_STORES || 'no';
const LOCALE = process.env.REACT_APP_LOCALE;
console.log(LOCALE,'test');

const {
  data: {
    buy: { [language]: buy },
    // freeTrial: { [language]: freeTrial },
    buy_pre_set: buyPresets,
  },
} = content;
const Navbar = ({props}) => {
  const { formatMessage } = useIntl();

  const { logout: logoutContext, lensKey } = useContext(Context);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isMobile, setMobile] = useState(false);
  const [iconType, setType] = useState(0);
  const [pageName, setPage] = useState('');
  const [currentRoute, setCurrentRoute] = useState('');

  const findUrl = process.env.REACT_APP_FIND_ECP;

  function toggle_Menu () {
    isMobile ? setMobile(false) : setMobile(true);
    if (!isMobile) {
      if (iconType === -2) {
        setType(0);
      }
      else {
        setType(iconType - 1);
      }
    }
  }

  const location = useLocation();
  const history = useHistory();

  const headerText = content['data']['header'][language];

  const redirectTo = (url) => {
    setMobile(false);
    history.push(url);

    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }, 100);
  }




  useEffect(() => {
    setPage(pageName);
    const currentUrl = location.pathname.split('/')[1];
    setPage(currentUrl);
    if (currentUrl === 'define-classic' || currentUrl === 'define-fresh') {
      setPage('discover');
    }

  }, [pageName, location]);

  return (
    <header>
      <div  className={`header--wrapper${isMenuOpen ? ' overlay' : ''}`}>
        <a
          onClick={() => redirectTo('/home')}
          className={`logo${isMobile ? ' hidden' : ''}`}
          >
          <img src={Icons.logoImage} alt="MyLook" width="90" height="40"/>
        </a>

        <label tabIndex="0" className={`menu-icon${ isMobile ? ' mobile-icon' : ''}`} onClick={toggle_Menu}>
          <div></div>
          <div></div>
          <div></div>
        </label>

        <nav className='menu-compact'>
          <ul className="menu-compact-list">
            <a data-route="home" onClick={() => redirectTo('/home')} className="list-item">
              <span className={`label${ pageName === 'home' ? ' current-route' : ''}`}>
                <FormattedMessage id="header.menu_01" defaultMessage='Home'/>
              </span>
              {pageName === 'home' && <img src={Icons.header_icon} className='indicator-icon' style={{ objectPosition: iconType + 'rem center'}}></img>}
            </a>
            <div className="list-item">
              <span data-route="discover" onClick={() => redirectTo('/discover')} className={`label link${ pageName === 'discover' ? ' current-route' : ''}`}>
                <FormattedMessage id="header.menu_02" defaultMessage='Discover Define® ' />
                {pageName === 'define-classic' && <img src={Icons.header_icon} className='indicator-icon' style={{ objectPosition: iconType + 'rem center'}}></img>}
              </span>
              <ul className="nested-links">
                {(language === 'twq' || language === "id") && (
                  <span data-route="discover" onClick={() => redirectTo('/discover')}>
                    <FormattedMessage id="header.list_menu_01" defaultMessage='The Catalogue' />
                  </span>
                )}
                <span data-route="define-classic" onClick={() => redirectTo('/define-classic')}>
                  <FormattedMessage id="header.list_menu_02" defaultMessage='Define® Classic' />
                </span>
                <span data-route="define-classic" onClick={() => redirectTo('/define-fresh')}>
                  <FormattedMessage id="header.list_menu_03" defaultMessage='Define® Fresh' />
                </span>
              </ul>
              {pageName === 'discover' && <img src={Icons.header_icon} className='indicator-icon' style={{ objectPosition: iconType + 'rem center'}}></img>}
            </div>
            <a data-route="vm" onClick={() => redirectTo('/vm')} className={`list-item${ pageName === 'vm' ? ' current-route' : ''}`}>
              <span className="item-icon">
                <Virtual_mirror />
              </span>
              <span className="label">
               <FormattedMessage id="header.menu_03" defaultMessage='Virtual Mirror' />
              </span>
              {pageName === 'vm' && <img src={Icons.header_icon} className='indicator-icon' style={{ objectPosition: iconType + 'rem center'}}></img>}
            </a>
            <a
              href={process.env.REACT_APP_FIND_ECP}
              target="_blank"
              className="list-item">
                <span className="label">
                 <FormattedMessage id="header.store_locator" defaultMessage='Store Locator' />
                </span>
                <span className="new-tab-icon"></span>
              </a>
            {/* TODO: store-links mobile */}
            { (ONLINE_STORES === "yes") && (
              <div className="stores">
                <div className="heading">
                  <FormattedMessage id="header.menu_04" defaultMessage='Shop Now' />
                </div>
                <ul className="store-links">
                  {/* <a
                    href="https://www.lazada.sg/shop/acuvue-official-store/"
                    target="_blank"
                    className="shop-link">
                    <div className="store-icon">
                      <Lazada_icon />
                    </div>
                    <FormattedMessage id="header.shop_01" defaultMessage='Lazada' />
                  </a>
                  <a
                    href="https://www.qoo10.sg/shop/acuvue"
                    target="_blank"
                    className="shop-link">
                    <div className="store-icon">
                      <Qoo10_icon />
                    </div>
                    <FormattedMessage id="header.shop_02" defaultMessage='Qoo10' />
                  </a> */}
                  <a href={formatMessage({ id: 'lazada_link', defaultMessage: 'https://s.lazada.co.th/s.r3sFa' })} target="_blank" className="shop-link">
                    <div className="store-icon">
                      {/* <Shopee_icon /> */}
                    </div>
                    <FormattedMessage id="header.shop_01" defaultMessage='Lazada' />
                  </a>

                  <a href={formatMessage({ id: 'acuvue_link', defaultMessage: 'https://www.acuvue.com/th-th/acuvue-to-home/' })} target="_blank" className="shop-link">
                    <div className="store-icon">
                      {/* <Shopee_icon /> */}
                    </div>
                    <FormattedMessage id="header.shop_02" defaultMessage='ACUVUE To Home' />
                  </a>
                </ul>
              </div>
            )}
          </ul>
        </nav>

        <nav className='menu-default'>
          <ul className='links'>
            <div className={`dropdown-toggle${ pageName === 'discover' ? ' current-route' : ''}`}>
              <FormattedMessage id="header.menu_02" defaultMessage='Discover Define® ' />
              <div className="dropdown-wrapper">
                <ul className="dropdown-list">
                  <a onClick={() => redirectTo('/discover')}>
                    <FormattedMessage id="header.list_menu_01" defaultMessage='The Catalogue' />
                  </a>
                  <a onClick={() => redirectTo('/define-classic')}>
                    <FormattedMessage id="header.list_menu_02" defaultMessage='Define® Classic' />
                  </a>
                  <a onClick={() => redirectTo('/define-fresh')}>
                    <FormattedMessage id="header.list_menu_03" defaultMessage='Define® Fresh' />
                  </a>
                </ul>
              </div>
            </div>
            <a data-route="vm" onClick={() => redirectTo('/vm')} className={`${ pageName === 'vm' ? ' current-route' : ''}`}>
              <span>
                <Virtual_mirror />
              </span>
              <FormattedMessage id="header.menu_03" defaultMessage='Virtual Mirror' />
            </a>
            <div className='dropdown-toggle stores'>
              <FormattedMessage id="header.menu_04" defaultMessage='Shop Now' />
              <div className='dropdown-wrapper'>
                <ul className='dropdown-list'>
                  <a target="_blank" href={process.env.REACT_APP_FIND_ECP}>
                    <FormattedMessage id="header.store_locator" defaultMessage='Store Locator' />
                  </a>

                  { ONLINE_STORES === 'yes' && LOCALE !== 'th' && (
                    <>
                      {/* <a href="https://www.lazada.sg/shop/acuvue-official-store/" target="_blank" className='shop-link'>
                        <div className='store-icon'> <Lazada_icon /> </div>
                        <FormattedMessage id="header.shop_01" defaultMessage='Lazada' />
                      </a>
                      <a href="https://www.qoo10.sg/shop/acuvue" target="_blank" className='shop-link'>
                        <div className='store-icon'> <Qoo10_icon /> </div>
                        <FormattedMessage id="header.shop_02" defaultMessage='Qoo10' />
                      </a> */}
                      <a href={formatMessage({ id: 'shopee_link', defaultMessage: 'https://shopee.sg/acuvuesg' })} target="_blank" className='shop-link'>
                        <div className='store-icon'> <Shopee_icon /> </div>
                        <FormattedMessage id="header.shop_03" defaultMessage='Shopee' />
                      </a>
                    </>
                  )}

                  { ONLINE_STORES === 'yes' && LOCALE === 'th' && (
                    <>
                      {/* <a href="https://www.lazada.sg/shop/acuvue-official-store/" target="_blank" className='shop-link'>
                        <div className='store-icon'> <Lazada_icon /> </div>
                        <FormattedMessage id="header.shop_01" defaultMessage='Lazada' />
                      </a>
                      <a href="https://www.qoo10.sg/shop/acuvue" target="_blank" className='shop-link'>
                        <div className='store-icon'> </div>
                        <FormattedMessage id="header.shop_01" defaultMessage='ACUVUE To Home' />
                      </a> */}
                      <a href={formatMessage({ id: 'lazada_link', defaultMessage: 'https://s.lazada.co.th/s.r3sFa' })} target="_blank" className='shop-link'>
                        <div className='store-icon'> </div>
                        <FormattedMessage id="header.shop_02" defaultMessage='Lazada' />
                      </a>
                      <a href={formatMessage({ id: 'acuvue_link', defaultMessage: 'https://www.acuvue.com/th-th/acuvue-to-home/' })} target="_blank" className='shop-link'>
                        <div className='store-icon'> </div>
                        <FormattedMessage id="header.shop_01" defaultMessage='ACUVUE To Home' />
                      </a>
                    </>
                  )}    

                </ul>
              </div>
            </div>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
